// Title y description por defecto de /anfitrionas, compartidos por la ruta pública y el inventario
// del panel SEO (mismo patrón que impulsadoras-promotoras.seo.ts). Las búsquedas de la página
// (Search Console, ago–oct 2026): «anfitrionas de eventos» (pos. 16), «agencia de anfitrionas» (19),
// «anfitrionas para eventos» (17) y «anfitrionas en lima» (24). El title las cubre en ese orden.

export const seo = {
  title: "Anfitrionas para Eventos en Lima | Agencia de Anfitrionas",
  description:
    "Agencia de anfitrionas para eventos en Lima: ferias, congresos y lanzamientos. Recepción, registro, protocolo y anfitrionas bilingües. Propuesta en 72 h.",
};
